/* eslint-disable react/prefer-stateless-function */
import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { LayersControl, TileLayer, WMSTileLayer } from 'react-leaflet';
import {
    basemapOptions,
    bymGrunnkart,
    format,
    kartlag,
    kartverketBaseMapAttribution,
    kartverketBaseMapUrl,
    OpenStreetContributors,
    openStreetMapLayer,
    sateliteBaseMap,
} from '../../constants/kartGlobals';
import { useGeonorge } from '../../context/Geonorge';

const KartlagControl = ({ grunnkart, checkboxes, setStatkartAvailable }) => {
    const { token } = useGeonorge();
    const safeToken = token ? encodeURIComponent(token) : '';
    const satelliteUrl = sateliteBaseMap.url.replace('{token}', safeToken);

    return (
        <LayersControl className="basmeap-layers-toggle-control" position="bottomright">
            <LayersControl.BaseLayer key="grunnkart" name="Grunnkart" checked={grunnkart === basemapOptions.grunnkart}>
                <TileLayer
                    url={kartverketBaseMapUrl}
                    ontileerror={() => setStatkartAvailable(false)}
                    attribution={kartverketBaseMapAttribution}
                />
            </LayersControl.BaseLayer>
            <LayersControl.BaseLayer
                key="detaljert_grunnkart"
                name="Detaljert grunnkart"
                checked={grunnkart === basemapOptions.detaljertGrunnkart}
            >
                <TileLayer url={openStreetMapLayer} attribution={OpenStreetContributors} />
            </LayersControl.BaseLayer>

            <LayersControl.BaseLayer
                key="satelittkart"
                name="satelittkart"
                checked={grunnkart === basemapOptions.satelittkart}
            >
                <TileLayer
                    url={satelliteUrl}
                    ontileerror={() => setStatkartAvailable(false)}
                    attribution={sateliteBaseMap.attribution}
                />
            </LayersControl.BaseLayer>

            <LayersControl.Overlay key="gatenavn" checked={grunnkart === basemapOptions.satelittkart}>
                <WMSTileLayer
                    key="gatenavn-2"
                    url="https://openwms.statkart.no/skwms1/wms.vegnett"
                    layers="vegnavn"
                    format={format}
                    transparent
                />
            </LayersControl.Overlay>

            <LayersControl.BaseLayer
                key={basemapOptions.bymBakgrunnskart}
                name={basemapOptions.bymBakgrunnskart}
                checked={grunnkart === basemapOptions.bymBakgrunnskart}
            >
                <TileLayer
                    url={bymGrunnkart.url}
                    attribution={bymGrunnkart.attribution}
                    resourceType="tile"
                    style="default"
                />
            </LayersControl.BaseLayer>

            {checkboxes.map(e => {
                const lag = _.find(kartlag, l => l.layerId === e);
                if (lag) {
                    const layerGroup = lag.layerId.split(',');
                    if (layerGroup.length > 1) {
                        return layerGroup.map(l => (
                            <LayersControl.Overlay key={l} checked>
                                <WMSTileLayer
                                    key={lag.layerId}
                                    url={lag.url}
                                    layers={l.trim()}
                                    format={format}
                                    transparent
                                    opacity={lag.opacity ? lag.opacity : 1}
                                />
                            </LayersControl.Overlay>
                        ));
                    }

                    return (
                        <LayersControl.Overlay key={lag.layerId} checked>
                            <WMSTileLayer
                                key={lag.layerId}
                                url={lag.url}
                                layers={lag.layerId}
                                format={format}
                                transparent
                                opacity={lag.opacity ? lag.opacity : 1}
                                crs={lag.crs || undefined}
                                styles={lag.styles || ''}
                            />
                        </LayersControl.Overlay>
                    );
                }
            })}
        </LayersControl>
    );
};

KartlagControl.propTypes = {
    grunnkart: PropTypes.string.isRequired,
    checkboxes: PropTypes.arrayOf(PropTypes.string).isRequired,
    position: PropTypes.string.isRequired,
    setStatkartAvailable: PropTypes.func.isRequired,
};

export default KartlagControl;
